import { Progress } from 'antd';
import styled from 'styled-components';

interface ProgressBarProps {
  percent: number;
}

const StyledProgress = styled(Progress)`
  .ant-progress-bg {
    background-color: #8cc63e;
  }
`;

const ProgressBar: React.FC<ProgressBarProps> = ({
  percent,
}: ProgressBarProps) => {
  return <StyledProgress percent={percent}></StyledProgress>;
};

export default ProgressBar;
